<script lang="ts">
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";

  export let label: string;
  export let value: string;
</script>

<div class="flex flex-col">
  <Typography
    mobile={TypographyType.Body2Regular}
    desktop={TypographyType.Body2Medium}
    copy={label}
    --font-color="var(--color-grayscale-90)" />
  <Typography mobile={TypographyType.Body1Medium} desktop={TypographyType.Headline5Medium}>
    <p class="whitespace-pre-wrap">{@html value}</p>
  </Typography>
</div>
